// https://www.npmjs.com/package/google-maps
export default class LocationMap {
	wrapper: HTMLElement;
	mapData: any;

	mapCenter: any;
	markerCenter: any;

	googleLoader: any;
	google: any;
	map: any;

	constructor() {
		if(document.getElementById("location-map-wrapper")) {
			this.wrapper = <HTMLElement> document.getElementById("location-map-wrapper");

			this.googleLoader = require('google-maps');
			this.googleLoader.KEY = 'AIzaSyDoc7ddnDOSYHgvcIg7YyR2RDbFIVh0aTA';
			this.googleLoader.LIBRARIES = ['places'];

			this.googleLoader.load((google) => {
				this.google = google; // Store the google library for future reference

				this.initMap(); // Create the map
			});
		}
	}

	initMap() {
		let mapEl = document.getElementById('location-map');
		if(mapEl) {
			let mapDataEl = document.getElementById('location-map-data');
			this.mapData = JSON.parse(mapDataEl.innerHTML);
			this.mapCenter = {lat: parseFloat(this.mapData.lat), lng: parseFloat(this.mapData.lng)};
			this.map = new this.google.maps.Map(mapEl, {
				center: this.mapCenter,
				zoom: 18,

				scrollwheel: false,
				// draggable: false,
				scaleControl: false,
				mapTypeControl: false,
				navigationControl: false,
				styles: [
				    {
				        "featureType": "transit",
				        "stylers": [
				            {
				                "visibility": "off"
				            }
				        ]
				    },
				    {
				        "featureType": "poi",
				        "stylers": [
				            {
				                "visibility": "off",
				            }
				        ]
				    }
				]
			});
			const encodedAddress = encodeURIComponent(this.mapData.address);
			const infoWindow = new this.google.maps.InfoWindow({
				content: `<a href="https://www.google.ca/maps/place/${encodedAddress}" target="__blank">${this.mapData.address}</a>`
			});



			var markerImage = {
				url: this.mapData.marker_img,
				size: new this.google.maps.Size(80, 80),
				origin: new this.google.maps.Point(0, 0),
				anchor: new this.google.maps.Point(40, 80)
			};

			var marker = new this.google.maps.Marker({
				position: this.mapCenter,
				icon: markerImage,
				map: this.map
			});

			infoWindow.open(this.map, marker);
		}
	}
}